// groupMembershipRequests.js
import store from '../../admin/store'
import omit from 'lodash.omit'

// Actions
export const DELETE_MEMBERSHIP_REQUEST = 'DELETE_MEMBERSHIP_REQUEST'

// Reducer
const initialState = {}

export const reducer = (state = initialState, action) => {
    switch(action.type) {
        case DELETE_MEMBERSHIP_REQUEST: {
            return omit(state, action.id)
        }
        default:
            return state
    }
}

// Action Creators
export const toggleBusy = () => ({
    type: 'TOGGLE_BUSY_SECTION',
    section: 'admin.groups.membershipRequests',
})

export const deleteMembershipRequest = id => ({
    type: DELETE_MEMBERSHIP_REQUEST,
    id,
})

export const deleteMembershipRequestRemote = (group, id) => {
    store.dispatch(toggleBusy())

    return window.axios.delete(
        `${window.APP_CONFIG.REACT_APP_API_URL}api/groups/${group.slug}/membership-requests/${id}`
    )
        .then(() => {
            store.dispatch(deleteMembershipRequest(id))
            store.dispatch(toggleBusy())
        }).catch(() => store.dispatch(toggleBusy()))
}
